<template>
  <div class="soundCloud">
    <iframe width="100%" height="166" scrolling="no" frameborder="no" allow="autoplay" src="https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/907679455&color=%23ff5500&auto_play=false&hide_related=false&show_comments=true&show_user=true&show_reposts=false&show_teaser=true"></iframe><div style="font-size: 10px; color: #cccccc;line-break: anywhere;word-break: normal;overflow: hidden;white-space: nowrap;text-overflow: ellipsis; font-family: Interstate,Lucida Grande,Lucida Sans Unicode,Lucida Sans,Garuda,Verdana,Tahoma,sans-serif;font-weight: 100;"><a href="https://soundcloud.com/dolphin2218" title="dolphinPW" target="_blank" style="color: #cccccc; text-decoration: none;">dolphinPW</a> · <a href="https://soundcloud.com/dolphin2218/pastel-world-3rd-album-adeyaka-xfd" title="Pastel World 3rd Album 「アデヤカ」 XFD" target="_blank" style="color: #cccccc; text-decoration: none;">Pastel World 3rd Album 「アデヤカ」 XFD</a></div>
  </div>
</template>

<script>
export default {
  name: 'SoundCloud',
};
</script>

<style lang="scss">
.soundCloud {
  margin-bottom: 20px;
}
</style>